module.exports = __webpack_public_path__ + "img/link_wg.6ad8617d.png";